import React, { createContext, useContext, useState } from "react";

/**
 * PageHeaderTrailContext — Round 22 (owner feedback).
 *
 * The page banner (DashboardPageHeader) publishes its title + breadcrumb
 * trail here; the fixed topbar (Layouts/Header.js) renders it. Result:
 * the page name and its clickable trail stay visible while the page
 * scrolls — on every module and sub-page, automatically — instead of
 * scrolling away with the in-page banner.
 *
 * Pages render banners exactly as before; no per-page wiring needed.
 * Pages without a banner simply leave the topbar slot empty.
 */
const PageHeaderTrailContext = createContext({ trail: null, setTrail: () => {} });

export const PageHeaderTrailProvider = ({ children }) => {
    const [trail, setTrail] = useState(null); // { title, crumbs: [{label, to?, onClick?}] }
    return (
        <PageHeaderTrailContext.Provider value={{ trail, setTrail }}>
            {children}
        </PageHeaderTrailContext.Provider>
    );
};

export const usePageHeaderTrail = () => useContext(PageHeaderTrailContext);

/**
 * TrailPrefixContext — owner 2026-10-12 ("this navigation should also change").
 *
 * A module whose screens live under ONE route (MAFIA Aux: menu > All Parts >
 * Edit Part) publishes the crumbs that sit between "Dashboard" and the screen
 * it renders: [{ label: "MAFIA Aux", onClick }, { label: "All Parts", onClick }].
 * DashboardPageHeader puts them in front of the screen's own last crumb, so the
 * topbar reads Dashboard > MAFIA Aux > All Parts > Edit Part, every crumb live.
 */
const TrailPrefixContext = createContext(null);

export const TrailPrefixProvider = ({ crumbs, children }) => (
    <TrailPrefixContext.Provider value={crumbs || null}>{children}</TrailPrefixContext.Provider>
);

export const useTrailPrefix = () => useContext(TrailPrefixContext);

export default PageHeaderTrailContext;
